// @flow
import React, { Component } from 'react'
import Select from 'react-select'
import { connect } from 'react-redux'
import styles from './categoryTags.less'
import * as actions from '../actions'
import { getTags, getAuth, getOpportunity } from '../selectors'
import TagValue from './TagValue'

const TAG_LIMIT = 5
class CategoryTags extends Component {
  props: {
    // action creators
    fetchCategoriesTagsIfNeeded: Function,
    putCategoryTagsIfNeeded: Function,
    // from state
    options: Array<Object>,
    value: Array<Object>,
    isFetching: boolean,
    id: number,
    disabled: boolean,
    isPuttingTags: boolean,
    putTagError: Object,
  }
  state: {
    value: ?Array<Object>,
  }

  componentWillMount() {
    this.props.fetchCategoriesTagsIfNeeded()
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.putTagError) {
      this.setState({ value: null })
    }
  }

  render() {
    const {
      id,
      isFetching,
      options,
      value,
      disabled,
      putCategoryTagsIfNeeded,
      isPuttingTags,
      putTagError,
    } = this.props
    let newVal = value
    if (this.state && this.state.value) {
      newVal = this.state.value
    }
    const isLimitReached = newVal.length >= TAG_LIMIT
    return (
      <div className={styles.select}>
        <Select
          name="tags"
          isLoading={isFetching || isPuttingTags}
          placeholder="Add at least one tag to show up in Discover"
          multi
          disabled={disabled}
          options={isLimitReached ? [] : options}
          noResultsText={
            isLimitReached ? 'You have reached the tag limit' : 'No tags found'
          }
          value={newVal}
          valueComponent={TagValue}
          onChange={value => this.setState({ value })}
          onBlur={() => {
            putCategoryTagsIfNeeded({ id, tags: newVal.map(tag => tag.label) })
          }}
        />
        {putTagError
          ? <div className="bg-danger">
              Error: {putTagError.response.message}
            </div>
          : null}
        {disabled
          ? <div>
              The org has modified these tags
            </div>
          : null}
        {isLimitReached
          ? <div>
              Tag limit is reached.
            </div>
          : null}
      </div>
    )
  }
}

const mapStateToProps = (state, { value }) => {
  const tags = getTags(state)
  const { email } = getAuth(state)
  const { isPuttingTags, putTagError } = getOpportunity(state)
  return {
    isFetching: tags.isFetching,
    isPuttingTags,
    putTagError,
    options: tags.items.map(tag => ({ label: tag, value: tag, email })),
    value: value
      ? value.map(tag => ({
          label: tag.name,
          value: tag.name,
          email: tag.createdByEmail,
        }))
      : [],
  }
}

export default connect(mapStateToProps, actions)(CategoryTags)



// WEBPACK FOOTER //
// ./src/components/CategoryTags.js